"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticsResponseToJSON = exports.DiagnosticsResponseFromJSONTyped = exports.DiagnosticsResponseFromJSON = exports.instanceOfDiagnosticsResponse = void 0;
var runtime_1 = require("../runtime");
var DiagnosticDatasource_1 = require("./DiagnosticDatasource");
/**
 * Check if a given object implements the DiagnosticsResponse interface.
 */
function instanceOfDiagnosticsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDiagnosticsResponse = instanceOfDiagnosticsResponse;
function DiagnosticsResponseFromJSON(json) {
    return DiagnosticsResponseFromJSONTyped(json, false);
}
exports.DiagnosticsResponseFromJSON = DiagnosticsResponseFromJSON;
function DiagnosticsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
        'datasources': !(0, runtime_1.exists)(json, 'datasources') ? undefined : (json['datasources'].map(DiagnosticDatasource_1.DiagnosticDatasourceFromJSON)),
    };
}
exports.DiagnosticsResponseFromJSONTyped = DiagnosticsResponseFromJSONTyped;
function DiagnosticsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataset_id': value.datasetId,
        'datasources': value.datasources === undefined ? undefined : (value.datasources.map(DiagnosticDatasource_1.DiagnosticDatasourceToJSON)),
    };
}
exports.DiagnosticsResponseToJSON = DiagnosticsResponseToJSON;
